import React from 'react';
import { Routes, Route } from 'react-router-dom';

import './styles/global.css';

import Navbar from './components/navbar';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/home';
import Team from './pages/team';
import Birthday from './pages/birthday';
import LocationsPage from './pages/ourLocations';
import ComingSoon from './pages/coomingSoon';
import Contact from './pages/contactPage';
import Privacy from './pages/privacy';
import Scholarship from './pages/scholarship';
import EventsPage from './pages/events';
import Individual from './pages/individual';
import Location from './pages/location';
import NotFound from './pages/notFound';

function App() {
  return (
    <div id="app-scroll">
      <Navbar />
      <ScrollToTop />

      <Routes>
        {/* Trasy stałe — React Router v6 przedkłada je nad dynamiczne,
            więc /kadra nigdy nie trafi do komponentu Location. */}
        <Route path="/" element={<Home />} />
        <Route path="/kadra" element={<Team />} />
        <Route path="/urodziny" element={<Birthday />} />
        <Route path="/lokalizacje" element={<LocationsPage />} />
        <Route path="/wkrotce-dostepne" element={<ComingSoon />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/polityka-prywatnosci" element={<Privacy />} />
        {/* <Route path="/stypendium" element={<Scholarship />} /> */}
        <Route path="/wydarzenia" element={<EventsPage />} />
        <Route path="/zajecia-indywidualne" element={<Individual />} />

        {/* Wszystkie lokalizacje — jedna trasa zamiast dwudziestu wpisów.
            Nowa lokalizacja = nowy dokument w locations_site, bez zmian w kodzie. */}
        <Route path="/:slug" element={<Location />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;